import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type FlatPageFragment = { id: string, pk: number, title: string, url: string, content: string, registrationRequired: boolean };

export const FlatPageFragmentDoc = gql`
    fragment FlatPageFragment on FlatPageType {
  id
  pk
  title
  url
  content
  registrationRequired
}
    `;